import isPropValid from '@emotion/is-prop-valid';

// DOM 전달 방지 스타일프롭스
const blockedProps = [
  'width',
  'maxWidth',
  'height',
  'multi',
  'right',
  'justifyContent',
  'gap',
  'active',
  'objectFit',
  'borderRadius',
  'shadow',
  'fourColumn',
  'sixColumn',
  'merge',
  'hover',
  'columns',
  'minWidth',
  'row',
  'sorted',
];

export const shouldForwardProp = (prop) => !blockedProps.includes(prop);
